import { useMedia } from "@next-platform/client-common-spicy-ui";
import React from "react";
import { useHits, useInstantSearch } from "react-instantsearch";

import useAuth from "@/services/useAuth";
import { Collection } from "@/types/api";

import { DisplayContext, IRefinementListProps } from "../types";
import FilterBoxCharacter from "./FilterBoxCharacter";
import FilterBoxLorebook from "./FilterBoxLorebook";
import { FilterOperator } from "./types";

export interface FilterBoxProps extends IRefinementListProps {
  useStoreTagFilters: boolean;
  isTagsDrawerVisible: boolean;
  setIsTagsDrawerVisible: (value: boolean) => void;
  isTagListMinimized: boolean;
  context?: DisplayContext;
  collection?: Collection;
  operator: FilterOperator;
}

const FilterBox = ({
  operator,
  useStoreTagFilters = true,
  isTagsDrawerVisible,
  setIsTagsDrawerVisible,
  isTagListMinimized,
  context,
  collection = Collection.CHARACTERS,
}: FilterBoxProps) => {
  const { status } = useInstantSearch();
  const isLoading = status === "loading" || status === "stalled";
  const { isDesktop } = useMedia();
  const { isAuthenticated } = useAuth();
  const { results } = useHits();

  const filterBoxProps = {
    results,
    isAuthenticated,
    isLoading,
    useStoreTagFilters,
    operator,
    isTagsDrawerVisible,
    setIsTagsDrawerVisible,
    isDesktop,
    isTagListMinimized,
  };

  return (
    <>
      {/* Rulebook tags come from the same predefined lorebook vocabulary (see RulebookTagsField). */}
      {(collection === Collection.LOREBOOKS || collection === Collection.RULEBOOKS) && <FilterBoxLorebook {...filterBoxProps} />}
      {collection === Collection.CHARACTERS && <FilterBoxCharacter {...filterBoxProps} context={context} />}
    </>
  );
};

export default React.memo(FilterBox);
